import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export const startAdminButtons = elementId => {
  const root = createRoot(document.getElementById(elementId))
  root.render(<App />)
}
